import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface State {
  loading: boolean;
  groups: Array<Group> | null | undefined;
  groupSitesAssetsData: Array<Group> | null | undefined;
  error: string | undefined;
  selectedAssetId: string | undefined;
  selectedGroup: string | undefined;
}

interface ActionPayload {
  assetGroupName: string | undefined;
  assetId: string | undefined;
  searchString: string | undefined;
}
interface Group {
  assetGroupName: string;
  assetIds: Array<string>;
  showAssets: boolean;
  class: string;
}
const initialState: State = {
  loading: false,
  groups: null,
  groupSitesAssetsData: null,
  error: undefined,
  selectedAssetId: undefined,
  selectedGroup: undefined,
};

const GroupSitesAssets = createSlice({
  name: "GroupSitesAssets",
  initialState,
  reducers: {
    ReducerGroupAssetsData: (state: any, action: any) => {
      state.groupSitesAssetsData = action.payload;
      return state;
    },
    updateAssetsDisplayState: (
      state: any,
      action: PayloadAction<ActionPayload>
    ) => {
      state.groupSitesAssetsData?.map((group: Group) => {
        if (group.assetGroupName == action.payload.assetGroupName) {
          const showAssets = !group.showAssets;
          group.showAssets = showAssets;
          group.class = showAssets
            ? "navigation-content-frame-item item-selected"
            : "navigation-content-frame-item";
        }
      });
    },
    updateSelectedAsset: (state, action: PayloadAction<ActionPayload>) => {
      state.selectedAssetId = action.payload.assetId;
      state.selectedGroup = action.payload.assetGroupName;
    },

    updateSearchGroups: (state, action: PayloadAction<ActionPayload>) => {
      const searchString = action.payload.searchString?.toLowerCase();
      const allGroups = state.groups;
      if (searchString) {
        state.groupSitesAssetsData = allGroups
          ?.filter((group) =>
            group.assetIds.some((asset) =>
              asset.toLowerCase().startsWith(searchString)
            )
          )
          .map((group) => ({
            ...group,
            assetIds: group.assetIds.filter((asset) =>
              asset.toLowerCase().startsWith(searchString)
            ),
            showAssets: true,
          }));
      } else {
        state.groupSitesAssetsData = state.groups;
      }
    },
  },
});

export const {
  ReducerGroupAssetsData,
  updateAssetsDisplayState,
  updateSelectedAsset,
  updateSearchGroups,
} = GroupSitesAssets.actions;

export default GroupSitesAssets;
